module.exports = __webpack_public_path__ + "media/cases-brand-suning-lazyload-31.23363fd2.mp4";